<template>
  <div id='nav'>
    <!-- <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component"
                   v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component"
                 v-if="!$route.meta.keepAlive" />
    </router-view> -->

    <router-view></router-view>
  </div>
</template>

<style lang="scss">
@import "./style/_layout.scss";
#nav {
  width: 100%;
  height: 100%;
}
</style>
